import initialState from './initialState'
import {
  ADD_USER,
  BEGIN_ADD_USER,
  FINISH_ADD_USER,
  ADD_IMAGE,
  BEGIN_ADD_IMAGE,
  FINISH_ADD_IMAGE,
  EDIT_TRAINING_PLAN,
  ADD_VIDEO_INFO,
} from '../actions/actionTypes'

export default function stuff(state = initialState.user, action) {
  let newState
  switch (action.type) {
    case BEGIN_ADD_USER:
      return { ...state, isLoading: true }
    case ADD_USER:
      newState = action.user
      return newState
    case FINISH_ADD_USER:
      return { ...state, isLoading: false }

    case BEGIN_ADD_IMAGE:
      return { ...state, isLoading: true }
    case ADD_IMAGE:
      newState = action.image

      if (action.side == 'side') {
        if (state.entries) {
          return {
            ...state,
            entries: [
              ...state.entries,
              {
                userSidePhoto: action.image,
                dateSlug: action.date,
              },
            ],
          }
        }
        return {
          ...state,
          entries: [
            {
              userSidePhoto: action.image,
              dateSlug: action.date,
            },
          ],
        }
      } else if (action.side == 'back') {
        if (state.entries) {
          return {
            ...state,
            entries: [
              ...state.entries,
              {
                userBackPhoto: action.image,
                dateSlug: action.date,
              },
            ],
          }
        }
        return {
          ...state,
          entries: [
            {
              userBackPhoto: action.image,
              dateSlug: action.date,
            },
          ],
        }
      } else {
        if (state.entries) {
          return {
            ...state,
            entries: [
              ...state.entries,
              {
                userFrontPhoto: action.image,
                dateSlug: action.date,
              },
            ],
          }
        }
        return {
          ...state,
          entries: [
            {
              userFrontPhoto: action.image,
              dateSlug: action.date,
            },
          ],
        }
      }

      function updateVeryNestedField(state, action) {
        return {
          ...state,
          first: {
            ...state.first,
            second: {
              ...state.first.second,
              [action.someId]: {
                ...state.first.second[action.someId],
                fourth: action.someValue,
              },
            },
          },
        }
      }

    case ADD_VIDEO_INFO:
      if (state.watchedVideos) {
        return {
          ...state,
          watchedVideos: {
            ...state.watchedVideos,
            [action.folderName]: {
              ...state.watchedVideos[action.folderName],
              [action.id]: action.videoViewInfo,
            },
          },
        }
      }

      //   ]
      //     [action.folderName]: [
      //       ...state.watchedVideos[action.folderName],
      //       { [action.id]: action.videoViewInfo },
      //     ],
      //   },
      // }
      else {
        return {
          ...state,
          watchedVideos: {
            [action.folderName]: { [action.id]: action.videoViewInfo },
          },
        }
      }

    case FINISH_ADD_IMAGE:
      return { ...state, isLoading: false }

    case EDIT_TRAINING_PLAN: {
      return {
        ...state,

        trainingDays: action.trainingDays,
      }
    }

    default:
      return state
  }
}
